import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";
import { lineItemsHandlingUnitsLimitExplanation } from "../Helpers/lineItemsHandlingUnitsLimitExplanation";

interface LineItemsTooManyHandlingUnitsQuestionBubbleProps {
  maxHandlingUnits: number;
}

export function LineItemsTooManyHandlingUnitsQuestionBubble(
  props: LineItemsTooManyHandlingUnitsQuestionBubbleProps,
) {
  return (
    <Tooltip
      variant="error"
      content={
        <Stack gap={2}>
          <T weight="bold">Too many handling units</T>
          <T size="xs" color="secondary">
            {lineItemsHandlingUnitsLimitExplanation(props.maxHandlingUnits)}
          </T>
        </Stack>
      }
    />
  );
}
